import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Redo"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.75 11.25C4.875 11.25 3.75 12.375 3.75 14.25C3.75 16.125 4.875 17.25 6.75 17.25H10.5V18.75H6.75C4.125 18.75 2.25 16.875 2.25 14.25C2.25 11.625 4.125 9.75 6.75 9.75H18.9L15.9 6.75L16.95 5.625L21.75 10.5L16.95 15.3L15.9 14.25L18.9 11.25H6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Redo.vue"]]);
